import { atom } from "jotai";

export const selectedEnvironmentAtom = atom();